import { create } from "zustand";

interface TagItem {
    id: number;
    name: string;
}
interface TagsStore {
    tags: any;
    setTags: (tags: any) => void;
    providersTags: any;
    setProvidersTags: (providersTags: any) => void;
    productsTags: any;
    setProductsTags: (productsTags: any) => void;
    providerCategories: TagItem[] | [];
    setProviderCategories: (categories: TagItem[]) => void;
    providerMetadata: any;
    setProviderMetadata: (metadata: any) => void;
    providerTopUser: TagItem | null;
    setProviderTopUser: (topUser: TagItem | null) => void;
    providerVerifiedUser: TagItem | null;
    setProviderVerifiedUser: (verifiedUser: TagItem | null) => void;
    providerLocation: TagItem[] | [];
    setProviderLocation: (location: TagItem[]) => void;
    productCategories: any[];
    setProductCategories: (categories: any[]) => void;
    subProductosTags: any;
    setSubProductosTags: (subProductosTags: any) => void;
}

export const useTagsStore = create<TagsStore>((set) => ({
    tags: [],
    setTags: (tags: any) => set({ tags }),
    providersTags: null,
    setProvidersTags: (providersTags: any) => set({ providersTags }),
    productsTags: null,
    setProductsTags: (productsTags: any) => set({ productsTags }),
    providerCategories: [],
    setProviderCategories: (providerCategories: any) => set({ providerCategories }),
    providerMetadata: null,
    setProviderMetadata: (providerMetadata: any) => set({ providerMetadata }),
    providerTopUser: null,
    setProviderTopUser: (providerTopUser: any) => set({ providerTopUser }),
    providerVerifiedUser: null,
    setProviderVerifiedUser: (providerVerifiedUser: any) => set({ providerVerifiedUser }),
    providerLocation: [],
    setProviderLocation: (providerLocation: any) => set({ providerLocation }),
    productCategories: [],
    setProductCategories: (productCategories: any) => set({ productCategories }),
    subProductosTags: null,
    setSubProductosTags: (subProductosTags: any) => set({ subProductosTags })
}));
